import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { initAnalytics } from "./lib/analytics";
import { TermlyScript } from "./components/TermlyScript";

// Initialize error tracking
initSentry();

// Initialize analytics
initAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <TermlyScript />
  </StrictMode>
);
